module.exports = __webpack_public_path__ + "static/nedre_foss.1598b920.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/graphics/nedre_foss.jpg
// module id = 333
// module chunks = 263791100135453